import { useQuery } from "@tanstack/react-query";
import { getUserRoleRequest } from "../requests/user";

export function useGetUserRole(config) {
  return useQuery({
    queryKey: [`/v1/user/role`, config],
    queryFn: async () => {
      const res = await getUserRoleRequest(config);
      return res.data?.data;
    },
  });
}
